<div id="captcha-container"></div>
<p *ngIf="errorMessage">{{errorMessage}}</p>
